import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledRoot = styled.svg`
  .localsearchlAnzac-cls-1,
  .localsearchlAnzac-cls-2 {
    fill: none;
  }
  .localsearchlAnzac-cls-1 {
    clip-rule: evenodd;
  }
  .localsearchlAnzac-cls-3 {
    clip-path: url(#clip-path);
  }
  .localsearchlAnzac-cls-4 {
    clip-path: url(#clip-path-2);
  }
  .localsearchlAnzac-cls-5 {
    fill: #071c27;
  }
  .localsearchlAnzac-cls-6 {
    clip-path: url(#clip-path-3);
  }
  .localsearchlAnzac-cls-7 {
    clip-path: url(#clip-path-5);
  }
  .localsearchlAnzac-cls-8 {
    clip-path: url(#clip-path-7);
  }
  .localsearchlAnzac-cls-9 {
    fill: #ec1f27;
  }
  .localsearchlAnzac-cls-10 {
    clip-path: url(#clip-path-9);
  }
  .localsearchlAnzac-cls-11 {
    fill: #d52027;
  }
  .localsearchlAnzac-cls-12 {
    clip-path: url(#clip-path-11);
  }
  .localsearchlAnzac-cls-13 {
    clip-path: url(#clip-path-13);
  }
  .localsearchlAnzac-cls-14 {
    clip-path: url(#clip-path-15);
  }
  .localsearchlAnzac-cls-15 {
    clip-path: url(#clip-path-17);
  }
  .localsearchlAnzac-cls-16 {
    fill: #fff;
  }
  .localsearchlAnzac-cls-17 {
    clip-path: url(#clip-path-19);
  }
  .localsearchlAnzac-cls-18 {
    clip-path: url(#clip-path-21);
  }
  .localsearchlAnzac-cls-19 {
    clip-path: url(#clip-path-23);
  }
  .localsearchlAnzac-cls-20 {
    clip-path: url(#clip-path-25);
  }
  .localsearchlAnzac-cls-21 {
    clip-path: url(#clip-path-27);
  }
  .localsearchlAnzac-cls-22 {
    isolation: isolate;
  }
  .localsearchlAnzac-cls-23 {
    clip-path: url(#clip-path-29);
  }
  .localsearchlAnzac-cls-24 {
    clip-path: url(#clip-path-30);
  }
  .localsearchlAnzac-cls-25 {
    fill: #ffcd05;
  }
  .localsearchlAnzac-cls-26 {
    clip-path: url(#clip-path-32);
  }
  .localsearchlAnzac-cls-27 {
    clip-path: url(#clip-path-34);
  }
  .localsearchlAnzac-cls-28 {
    clip-path: url(#clip-path-36);
  }
  .localsearchlAnzac-cls-29 {
    clip-path: url(#clip-path-38);
  }
  .localsearchlAnzac-cls-30 {
    clip-path: url(#clip-path-40);
  }
  .localsearchlAnzac-cls-31 {
    clip-path: url(#clip-path-42);
  }
  .localsearchlAnzac-cls-32 {
    clip-path: url(#clip-path-44);
  }
  .localsearchlAnzac-cls-33 {
    clip-path: url(#clip-path-46);
  }
  .localsearchlAnzac-cls-34 {
    clip-path: url(#clip-path-48);
  }
  .localsearchlAnzac-cls-35 {
    clip-path: url(#clip-path-50);
  }
  .localsearchlAnzac-cls-36 {
    clip-path: url(#clip-path-52);
  }
  .localsearchlAnzac-cls-37 {
    clip-path: url(#clip-path-54);
  }
  .localsearchlAnzac-cls-38 {
    clip-path: url(#clip-path-55);
  }
  .localsearchlAnzac-cls-39 {
    clip-path: url(#clip-path-56);
  }
  .localsearchlAnzac-cls-40 {
    clip-path: url(#clip-path-57);
  }
  .localsearchlAnzac-cls-41 {
    clip-path: url(#clip-path-58);
  }
  .localsearchlAnzac-cls-42 {
    clip-path: url(#clip-path-59);
  }
  .localsearchlAnzac-cls-43 {
    clip-path: url(#clip-path-60);
  }
  .localsearchlAnzac-cls-44 {
    clip-path: url(#clip-path-61);
  }
  .localsearchlAnzac-cls-45 {
    clip-path: url(#clip-path-62);
  }
  .localsearchlAnzac-cls-46 {
    clip-path: url(#clip-path-63);
  }
  .localsearchlAnzac-cls-47 {
    clip-path: url(#clip-path-64);
  }
  .localsearchlAnzac-cls-48 {
    clip-path: url(#clip-path-65);
  }
  .localsearchlAnzac-cls-49 {
    clip-path: url(#clip-path-66);
  }
  .localsearchlAnzac-cls-50 {
    clip-path: url(#clip-path-67);
  }
  .localsearchlAnzac-cls-51 {
    clip-path: url(#clip-path-68);
  }
  .localsearchlAnzac-cls-52 {
    clip-path: url(#clip-path-69);
  }
  .localsearchlAnzac-cls-53 {
    clip-path: url(#clip-path-70);
  }
  .localsearchlAnzac-cls-54 {
    clip-path: url(#clip-path-71);
  }
  .localsearchlAnzac-cls-55 {
    clip-path: url(#clip-path-72);
  }
  .localsearchlAnzac-cls-56 {
    font-size: 10.64px;
    fill: #fcfafc;
    font-family: CircularTT-Book, Circular TT;
  }
`;

function SantaLocalsearchLogo({ width, height }) {
  return (
    <StyledRoot
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1918.66 518.33"
      width={width}
      height={height}
    >
      <defs>
        <clipPath id="clip-path">
          <path
            className="localsearchlAnzac-cls-1"
            d="M559.21,255.88q270.88,34.1,535.25,6.3T1616.7,144.74l21.46,204.2a2249.47,2249.47,0,0,1-517.52,117q-266.31,28-540-5.81Z"
          />
        </clipPath>
        <clipPath id="clip-path-2">
          <rect
            className="localsearchlAnzac-cls-2"
            x="-2238.77"
            y="-596.25"
            width="16643.04"
            height="11835.05"
          />
        </clipPath>
        <clipPath id="clip-path-3">
          <polygon
            className="localsearchlAnzac-cls-1"
            points="1624.92 134.49 1891.59 106.46 1819.92 213.46 1913.05 310.66 1646.38 338.69 1624.92 134.49"
          />
        </clipPath>
        <clipPath id="clip-path-5">
          <polygon
            className="localsearchlAnzac-cls-1"
            points="570.51 275.6 303.84 247.57 375.5 354.57 282.38 451.77 549.04 479.8 570.51 275.6"
          />
        </clipPath>
        <clipPath id="clip-path-7">
          <path
            className="localsearchlAnzac-cls-1"
            d="M1520.65,165.34q13.47-34.05,33.15-41.71c19.69-7.66,19.28-14.84,30.81-14.84s14-1.37,22,17.81q8,19.17,2.75,73.71-56,.51-77.36-5.85T1520.65,165.34Z"
          />
        </clipPath>
        <clipPath id="clip-path-9">
          <path
            className="localsearchlAnzac-cls-1"
            d="M1687.66,165.56q-13.47-34-33.15-41.71c-19.69-7.66-19.28-14.85-30.81-14.85s-14-1.37-22,17.82q-8,19.17-2.75,73.71,56,.51,77.36-5.85T1687.66,165.56Z"
          />
        </clipPath>
        <clipPath id="clip-path-11">
          <path
            className="localsearchlAnzac-cls-1"
            d="M1574,278.94q-33.91-13.51-41.55-33.28c-7.63-19.76-14.79-19.36-14.79-30.93s-1.36-14,17.75-22.11q19.1-8.07,73.42-2.76.51,56.25-5.82,77.67T1574,278.94Z"
          />
        </clipPath>
        <clipPath id="clip-path-13">
          <path
            className="localsearchlAnzac-cls-1"
            d="M1632,276.42q33.91-13.51,41.55-33.28c7.63-19.77,14.78-19.36,14.78-30.93s1.37-14-17.74-22.11q-19.11-8.07-73.43-2.76-.51,56.25,5.83,77.67T1632,276.42Z"
          />
        </clipPath>
        <clipPath id="clip-path-15">
          <path
            className="localsearchlAnzac-cls-1"
            d="M1624.53,196.66c.86,1,4.11,9.08-.87,9.88s-3.89,6.71-6.36,6.71-4.88,8.29-6.16,6-2.51,0-11.26,0q-8.76,0-10.15-3-12.07-5-10.57-10.5c1.5-5.54-.32-9.08-.81-12.48s.81-4.46,3-6.75-1.22-1.14.87-3.77,6.51-.65,5.59-4.36q-.91-3.7,8.63-6.86,14.79-1.92,18,2.32c3.21,4.23,6.07-1.82,6.54,2.3a14.32,14.32,0,0,0,3.51,7.71c2.45,4.67,3,7.8,1.77,9.41C1624.39,195.67,1623.66,195.69,1624.53,196.66Z"
          />
        </clipPath>
        <clipPath id="clip-path-17">
          <rect
            className="localsearchlAnzac-cls-2"
            x="3.42"
            y="4.74"
            width="46.23"
            height="231.15"
          />
        </clipPath>
        <clipPath id="clip-path-19">
          <rect
            className="localsearchlAnzac-cls-2"
            x="569.74"
            y="4.74"
            width="46.23"
            height="231.15"
          />
        </clipPath>
        <clipPath id="clip-path-21">
          <path
            className="localsearchlAnzac-cls-1"
            d="M406.63,193.09a45.13,45.13,0,0,1,3.66-18.48,44.16,44.16,0,0,1,9.85-14,47.09,47.09,0,0,1,14.52-9.42,79,79,0,0,1,17.91-5l37.68-5.53q6.54-.91,9-3.92a10.76,10.76,0,0,0,2.52-7.1,18.94,18.94,0,0,0-6.33-14.26q-6.35-6-19.42-6.08-13.69-.06-21,7.5a28.67,28.67,0,0,0-8.31,17.67L410,126.38a51.85,51.85,0,0,1,5.68-18.31,56.45,56.45,0,0,1,12.82-16.39,64,64,0,0,1,20-11.77q11.83-4.53,27.4-4.48,18.06.07,30.79,5t20.65,13.05a48.14,48.14,0,0,1,11.44,18.86,70.61,70.61,0,0,1,3.49,22.47l-.31,76.51c0,4.23.17,8.7.57,13.45s.8,8.49,1.2,11.22l-38-.16a83.58,83.58,0,0,1-1.05-8.7q-.45-5.52-.43-10a53.73,53.73,0,0,1-17,16.06q-11.08,6.9-28.2,6.84a58.24,58.24,0,0,1-21.93-4,52.33,52.33,0,0,1-16.6-10.51,44.21,44.21,0,0,1-13.88-32.46Zm61.25,15.74a45.52,45.52,0,0,0,12.61-1.68,26.58,26.58,0,0,0,10.76-6,30.29,30.29,0,0,0,7.52-11q2.84-6.78,2.87-17.22l0-7-34.57,5.24A26.91,26.91,0,0,0,453.54,177q-5.46,4.56-5.51,13.73A18.2,18.2,0,0,0,453,203.24Q457.92,208.79,467.88,208.83Z"
          />
        </clipPath>
        <clipPath id="clip-path-23">
          <path
            className="localsearchlAnzac-cls-1"
            d="M221.66,124.4c-.09-.23-.14-.47-.23-.7a78,78,0,0,0-16.7-26.15,77,77,0,0,0-25.46-17.18,85.55,85.55,0,0,0-63.8-.26,77.11,77.11,0,0,0-25.59,17,78.22,78.22,0,0,0-16.91,26,88.82,88.82,0,0,0-6.2,33.18,87.25,87.25,0,0,0,5.94,33.06,80.06,80.06,0,0,0,16.7,26.16,75.7,75.7,0,0,0,25.45,17.34,85.55,85.55,0,0,0,63.8.26A75.74,75.74,0,0,0,204.26,216a80,80,0,0,0,16.9-26c.1-.25.17-.53.28-.78A113,113,0,0,1,217,156.89a116.11,116.11,0,0,1,4.63-32.49m-39,51.64A41.93,41.93,0,0,1,174,189.75a34.75,34.75,0,0,1-12.48,8.33,38.95,38.95,0,0,1-29.25-.12,34.73,34.73,0,0,1-12.42-8.43,42.07,42.07,0,0,1-8.51-13.79,52.33,52.33,0,0,1-3.19-19.3,52.11,52.11,0,0,1,3.35-19.28,42.2,42.2,0,0,1,8.61-13.71,34.75,34.75,0,0,1,12.48-8.33,39,39,0,0,1,29.27.12,35,35,0,0,1,12.41,8.43,42,42,0,0,1,8.5,13.79,52,52,0,0,1,3.19,19.3A51.87,51.87,0,0,1,182.62,176"
          />
        </clipPath>
        <clipPath id="clip-path-25">
          <path
            className="localsearchlAnzac-cls-1"
            d="M320.59,113.68a39.76,39.76,0,0,0-15.11,2.79,35.11,35.11,0,0,0-12.32,8.33,40,40,0,0,0-8.46,13.71,52.44,52.44,0,0,0-3.19,18.65,52.11,52.11,0,0,0,3,18.66,40.41,40.41,0,0,0,8.51,14,35.6,35.6,0,0,0,12.41,8.59,39.75,39.75,0,0,0,15.08,2.91A37.94,37.94,0,0,0,334.41,199a35.4,35.4,0,0,0,10.45-6.13,32,32,0,0,0,7-8.51,42.63,42.63,0,0,0,3.92-9.15l36.37,12.48a68.57,68.57,0,0,1-8.32,19.1A67.79,67.79,0,0,1,369,223.44a74.25,74.25,0,0,1-21.21,11.93,77.15,77.15,0,0,1-27.4,4.48,81.34,81.34,0,0,1-31.57-6.3,77.33,77.33,0,0,1-25.6-17.34,80.87,80.87,0,0,1-17-26.16A85.44,85.44,0,0,1,240.12,157a88.57,88.57,0,0,1,6.2-33.17,76.74,76.74,0,0,1,42.19-43,84.36,84.36,0,0,1,59.14-1.33,76.13,76.13,0,0,1,21.27,11.94,62.06,62.06,0,0,1,14.56,16.82,73.32,73.32,0,0,1,8,19.32l-37.08,12.5A42.77,42.77,0,0,0,343.74,122q-7.89-8.25-23.15-8.32"
          />
        </clipPath>
        <clipPath id="clip-path-27">
          <rect
            className="localsearchlAnzac-cls-2"
            x="3.42"
            y="7.3"
            width="1465.29"
            height="355.74"
          />
        </clipPath>
        <clipPath id="clip-path-29">
          <rect
            className="localsearchlAnzac-cls-2"
            x="-8.14"
            y="4.74"
            width="1479.38"
            height="358.29"
          />
        </clipPath>
        <clipPath id="clip-path-30">
          <rect
            className="localsearchlAnzac-cls-2"
            x="3.42"
            y="320.98"
            width="604.7"
            height="42.06"
          />
        </clipPath>
        <clipPath id="clip-path-32">
          <path
            className="localsearchlAnzac-cls-1"
            d="M662.89,235c-6.19-2.37-12.42-6.51-18.5-11.79a52.39,52.39,0,0,1-11.88-15,46.88,46.88,0,0,1-5.25-16.14l-.1-.92,20-6.78.2,1.24A39.87,39.87,0,0,0,659.75,209c6.77,6.35,16.51,9.59,28.94,9.64,9.5,0,17.54-2.44,23.89-7.25s9.54-11,9.57-18.93c0-6.84-2.11-12.07-6.56-16s-10.82-6.95-18.82-8.85l-25-5.9c-11.63-2.65-21.07-7.5-28.09-14.41s-10.65-16.26-10.6-27.67a38.87,38.87,0,0,1,4.41-18,48,48,0,0,1,11.69-14.6,56.2,56.2,0,0,1,17-9.79,58.15,58.15,0,0,1,20.28-3.53c9.36,0,17.46,1.28,24.05,3.7a52.88,52.88,0,0,1,16.72,9.62,46,46,0,0,1,10.59,13.22,61,61,0,0,1,5.39,14.11l.22.9L724,122.47l-.23-1.28a36.73,36.73,0,0,0-3.59-10.5,31.44,31.44,0,0,0-7-9.06,35.69,35.69,0,0,0-11-6.44,44.11,44.11,0,0,0-15.52-2.56,40.44,40.44,0,0,0-12.18,1.82,32.86,32.86,0,0,0-10.24,5.26,26.57,26.57,0,0,0-7.06,8.17,21.54,21.54,0,0,0-2.68,10.61c-.05,12.22,7.62,19.92,23.43,23.53l24.68,5.59c13.12,3.09,23.35,8.32,30.38,15.57s10.63,16.76,10.59,28.16a42.12,42.12,0,0,1-3.73,17.2,46.4,46.4,0,0,1-10.71,14.9c-5.66,5.31-11.57,9.47-17.3,11.88-13.1,5.49-33.65,5.49-48.9-.35"
          />
        </clipPath>
        <clipPath id="clip-path-34">
          <path
            className="localsearchlAnzac-cls-1"
            d="M808.15,233.8a76.78,76.78,0,0,1-40.74-43.43c-4-10.17-6-22-5.94-35a90.43,90.43,0,0,1,6.06-33.25,82.86,82.86,0,0,1,15.91-25.72,69.72,69.72,0,0,1,23.18-16.6,68.45,68.45,0,0,1,27.82-5.79c11.77,0,22.29,2.07,31.27,6a66.19,66.19,0,0,1,22.9,16.46A73.76,73.76,0,0,1,903,121.4,93.88,93.88,0,0,1,908,153v3.54a33.62,33.62,0,0,1-.42,4.41l-124.09-.31v1.13a62,62,0,0,0,4.21,22.72,55.2,55.2,0,0,0,11.73,18.22,52.48,52.48,0,0,0,17.3,11.74,54.61,54.61,0,0,0,21,4.18c13.59,0,24.57-3.44,32.63-10.23a54.81,54.81,0,0,0,17.17-25.2l19.29,6.88a74.78,74.78,0,0,1-9.47,18.64,69.74,69.74,0,0,1-14.92,15.59,81.43,81.43,0,0,1-20,11.51c-13.28,5-38.49,5-54.23-2m6.5-136.4a48.92,48.92,0,0,0-15.44,10.65A51.46,51.46,0,0,0,788.69,124a57.36,57.36,0,0,0-4.41,17.25l-.13,1.23,101.18.43-.08-1.19a59.34,59.34,0,0,0-3.65-17.33,48.18,48.18,0,0,0-9.8-15.87,45,45,0,0,0-15.66-10.6,50.59,50.59,0,0,0-21.42-4.32,49.08,49.08,0,0,0-20.07,3.84"
          />
        </clipPath>
        <clipPath id="clip-path-36">
          <path
            className="localsearchlAnzac-cls-1"
            d="M1446.6,236.39l.41-98.29a56.28,56.28,0,0,0-2.33-16.61,35.25,35.25,0,0,0-7.36-13.32,35.89,35.89,0,0,0-12.59-9c-5-2.2-11.19-3.33-18.39-3.36A39.1,39.1,0,0,0,1389,99.69,40.83,40.83,0,0,0,1375.61,110a48.51,48.51,0,0,0-8.49,14.94,52.43,52.43,0,0,0-3.09,17.67l-.39,93.47L1342,236l1-228.45,21.69,0-.41,95.65,2.06-3.61c3.11-5.45,6.3-9.23,15.12-14.71,9-5.6,19.51-8.45,31.22-8.45,9.42,0,17.77,1.62,24.81,4.7A49.52,49.52,0,0,1,1455,93.65a52.41,52.41,0,0,1,10.38,18.61,73.58,73.58,0,0,1,3.37,22.71l-.42,101.51Z"
          />
        </clipPath>
        <clipPath id="clip-path-38">
          <path
            className="localsearchlAnzac-cls-1"
            d="M1216.5,234.12c-9.11-3.83-17.25-10.05-24.34-17.58a78.32,78.32,0,0,1-16-26,91.69,91.69,0,0,1-5.63-32.91,92.8,92.8,0,0,1,5.9-33,77.77,77.77,0,0,1,16.25-26,73.48,73.48,0,0,1,24.65-16.9,82.15,82.15,0,0,1,56.07-1.88A64.58,64.58,0,0,1,1293,90.63a66,66,0,0,1,14,15.77,67.25,67.25,0,0,1,8.18,18.66l-19.37,7.56a65,65,0,0,0-5.54-13.33,48.92,48.92,0,0,0-9.34-12,44.72,44.72,0,0,0-13.92-8.7,51.56,51.56,0,0,0-19.07-3.37,55.13,55.13,0,0,0-21.51,4.17,51.12,51.12,0,0,0-17.55,12.23,60.56,60.56,0,0,0-12.06,19.73,73.77,73.77,0,0,0-4.6,26.36,74.27,74.27,0,0,0,4.22,25.92,57.73,57.73,0,0,0,11.89,19.71,53.62,53.62,0,0,0,17.64,12.13,51.53,51.53,0,0,0,21.46,4.2c8,0,14.09-1,19.25-3.08a50.84,50.84,0,0,0,14.5-8.7,48.65,48.65,0,0,0,9.92-11.65,58.19,58.19,0,0,0,5.8-12.73l19.29,7.89a76,76,0,0,1-8.63,17.81,64.6,64.6,0,0,1-14.45,15.61,72.46,72.46,0,0,1-20.16,11.33c-19.14,6.9-40.51,4.67-56.41-2"
          />
        </clipPath>
        <clipPath id="clip-path-40">
          <path
            className="localsearchlAnzac-cls-1"
            d="M957.48,235.72a51.66,51.66,0,0,1-16.07-10.78,43.48,43.48,0,0,1-9.94-14.43A42.16,42.16,0,0,1,928,193.74c.06-13.35,4.43-24,13-31.68s20.15-12.53,34.61-14.65l41.3-6c6.39-1,10.59-2.69,12.48-5a13.41,13.41,0,0,0,2.9-8.68c0-10.11-3.07-18.1-9.5-24.41s-15.85-9.41-28.27-9.46c-12.08,0-22,3.07-29.39,9.12s-11.91,14.68-13.22,25.5l-.13,1.17-20.34-4.4.11-1A53,53,0,0,1,938.3,104a54.44,54.44,0,0,1,13.49-15.55,61.8,61.8,0,0,1,19.07-9.91A74.23,74.23,0,0,1,993.94,75c10.29,0,19.34,1.52,26.9,4.37a51,51,0,0,1,18.71,11.77,48,48,0,0,1,10.9,17.48,61.53,61.53,0,0,1,3.55,21.13l-.32,76.12c0,6.19,1.85,25.37,3.21,30.21l-21.09,0c-1.17-4.84-3-20.51-3.07-23.76l-.09-1.87-1.88,3.21a50,50,0,0,1-15.69,15c-5.62,3.54-10.8,6.51-15.72,8.2C985.44,241.6,965.16,238.77,957.48,235.72Zm72.9-79.5a32.32,32.32,0,0,1-8.31,2.15l-43.24,6.28c-8.82,1.21-15.91,4.23-21.06,9s-7.67,11-7.71,19.21c0,6.84,2.55,12.7,8.08,18.44,5.35,5.55,13.38,8.36,23.87,8.36a56.82,56.82,0,0,0,20.09-3.29,46.91,46.91,0,0,0,15.92-9.73,42.57,42.57,0,0,0,10.37-15.29,55.06,55.06,0,0,0,3.75-20.49l.06-15.44Z"
          />
        </clipPath>
        <clipPath id="clip-path-42">
          <path
            className="localsearchlAnzac-cls-1"
            d="M1086.48,236.11l.66-160.88,21.77,0-.09,25.6,2-2.67c13.48-18.66,28.75-23.51,45.37-23.51,5.62,0,9.85.61,12.94,1.8l.71.3-.08,21s-30.94-9.32-47.75,7.76c-8.42,8.56-13,20.34-13.08,37.91l-.36,92.69Z"
          />
        </clipPath>
        <clipPath id="clip-path-44">
          <path
            className="localsearchlAnzac-cls-1"
            d="M525.84,423.86q9.88-22.69,24.31-27.8c14.44-5.11,14.14-9.9,22.6-9.9S583,385.25,588.9,398q5.9,12.78,2,49.14-41.08.35-56.73-3.9T525.84,423.86Z"
          />
        </clipPath>
        <clipPath id="clip-path-46">
          <path
            className="localsearchlAnzac-cls-1"
            d="M648.32,424Q638.43,401.32,624,396.2c-14.44-5.1-14.14-9.89-22.6-9.89s-10.25-.92-16.15,11.87q-5.89,12.79-2,49.15,41.09.33,56.73-3.9T648.32,424Z"
          />
        </clipPath>
        <clipPath id="clip-path-48">
          <path
            className="localsearchlAnzac-cls-1"
            d="M565,499.6q-24.87-9-30.46-22.19c-5.6-13.17-10.85-12.9-10.85-20.62s-1-9.36,13-14.74q14-5.39,53.85-1.84.38,37.5-4.27,51.78T565,499.6Z"
          />
        </clipPath>
        <clipPath id="clip-path-50">
          <path
            className="localsearchlAnzac-cls-1"
            d="M607.49,497.92q24.87-9,30.46-22.19c5.6-13.17,10.85-12.9,10.85-20.62s1-9.36-13-14.74q-14-5.39-53.85-1.84-.37,37.5,4.27,51.78T607.49,497.92Z"
          />
        </clipPath>
        <clipPath id="clip-path-52">
          <path
            className="localsearchlAnzac-cls-1"
            d="M602,444.75c.64.64,3,6.05-.64,6.58s-2.85,4.48-4.66,4.48-3.58,5.52-4.52,4-1.83,0-8.26,0q-6.42,0-7.44-2-8.85-3.3-7.75-7c1.1-3.69-.24-6.05-.6-8.32s.6-3,2.23-4.5-.89-.76.64-2.51,4.78-.44,4.1-2.91q-.68-2.47,6.33-4.57,10.84-1.29,13.2,1.54c2.36,2.82,4.45-1.21,4.8,1.53A9.23,9.23,0,0,0,602,436.2c1.8,3.12,2.24,5.21,1.3,6.28C601.92,444.09,601.38,444.1,602,444.75Z"
          />
        </clipPath>
        <clipPath id="clip-path-54">
          <path
            className="localsearchlAnzac-cls-1"
            d="M39.26-269.78a100.71,100.71,0,0,0,27.15,2.36,100.55,100.55,0,0,0,26.76-5.12l.66,12.34a97.54,97.54,0,0,1-26.52,5.11,102.66,102.66,0,0,1-27.4-2.35Z"
          />
        </clipPath>
        <clipPath id="clip-path-55">
          <polygon
            className="localsearchlAnzac-cls-1"
            points="94.1 -273.69 103.09 -274.14 100.64 -268.06 103.74 -261.8 94.76 -261.35 94.1 -273.69"
          />
        </clipPath>
        <clipPath id="clip-path-56">
          <polygon
            className="localsearchlAnzac-cls-1"
            points="38.53 -270.32 29.55 -269.84 32.62 -264.04 30.19 -257.5 39.17 -257.99 38.53 -270.32"
          />
        </clipPath>
        <clipPath id="clip-path-57">
          <path
            className="localsearchlAnzac-cls-1"
            d="M87.68-272.16a4.11,4.11,0,0,1,2.15-2.41c1.21-.39,1.21-.83,1.91-.79s.85,0,1.28,1.14a10.68,10.68,0,0,1-.07,4.44,18.69,18.69,0,0,1-4.67-.6C87.43-270.68,87.23-271.27,87.68-272.16Z"
          />
        </clipPath>
        <clipPath id="clip-path-58">
          <path
            className="localsearchlAnzac-cls-1"
            d="M97.81-271.62a4.09,4.09,0,0,0-1.88-2.61c-1.17-.53-1.12-1-1.82-1s-.84-.13-1.39,1a10.48,10.48,0,0,0-.4,4.42,18.52,18.52,0,0,0,4.71-.11Q98.34-270.23,97.81-271.62Z"
          />
        </clipPath>
        <clipPath id="clip-path-59">
          <path
            className="localsearchlAnzac-cls-1"
            d="M90.56-265.17a4.09,4.09,0,0,1-2.41-2.13c-.4-1.21-.84-1.21-.8-1.91s0-.84,1.15-1.27a10.77,10.77,0,0,1,4.46.07,18.57,18.57,0,0,1-.6,4.65C92.06-264.92,91.46-264.72,90.56-265.17Z"
          />
        </clipPath>
        <clipPath id="clip-path-60">
          <path
            className="localsearchlAnzac-cls-1"
            d="M94.08-265.14A4.13,4.13,0,0,0,96.71-267c.52-1.17,1-1.12,1-1.82s.13-.83-1-1.38a10.81,10.81,0,0,0-4.45-.4,18.35,18.35,0,0,0,.11,4.69C92.57-265,93.15-264.78,94.08-265.14Z"
          />
        </clipPath>
        <clipPath id="clip-path-61">
          <path
            className="localsearchlAnzac-cls-1"
            d="M93.88-269.95c.05.06.22.56-.08.59s-.26.39-.41.38-.32.48-.39.34-.15,0-.68,0c-.36,0-.56-.09-.61-.22-.47-.22-.68-.44-.61-.66a1.43,1.43,0,0,0,0-.75c0-.21.07-.27.21-.4s-.07-.07.07-.22.39,0,.35-.25.15-.28.54-.38c.6-.05,1,0,1.09.19s.37-.09.39.16a.89.89,0,0,0,.18.48c.14.29.16.48.08.57S93.83-270,93.88-269.95Z"
          />
        </clipPath>
        <clipPath id="clip-path-62">
          <path
            className="localsearchlAnzac-cls-1"
            d="M36.56-259.79a2.75,2.75,0,0,1,1.56-1.59c.89-.26.89-.55,1.4-.53s.62,0,.94.77a6.49,6.49,0,0,1,0,3A14.41,14.41,0,0,1,37-258.6C36.38-258.8,36.23-259.2,36.56-259.79Z"
          />
        </clipPath>
        <clipPath id="clip-path-63">
          <path
            className="localsearchlAnzac-cls-1"
            d="M44-259.39a2.82,2.82,0,0,0-1.38-1.75c-.86-.35-.83-.64-1.34-.67s-.62-.08-1,.67A6.49,6.49,0,0,0,40-258.2a15,15,0,0,0,3.46-.05C44.06-258.39,44.25-258.77,44-259.39Z"
          />
        </clipPath>
        <clipPath id="clip-path-64">
          <path
            className="localsearchlAnzac-cls-1"
            d="M38.69-255.11a3,3,0,0,1-1.77-1.43c-.3-.81-.62-.81-.6-1.28s0-.56.84-.84a8.48,8.48,0,0,1,3.27.06,11.85,11.85,0,0,1-.42,3.1Q39.68-254.66,38.69-255.11Z"
          />
        </clipPath>
        <clipPath id="clip-path-65">
          <path
            className="localsearchlAnzac-cls-1"
            d="M41.27-255.08a2.93,2.93,0,0,0,1.92-1.24c.38-.77.7-.74.72-1.2s.09-.56-.74-.93a8.7,8.7,0,0,0-3.26-.28,11.23,11.23,0,0,0,.1,3.13C40.17-255,40.59-254.85,41.27-255.08Z"
          />
        </clipPath>
        <clipPath id="clip-path-66">
          <path
            className="localsearchlAnzac-cls-1"
            d="M41.11-258.29s.16.37-.06.39-.19.26-.3.26-.23.32-.28.22-.11,0-.5,0-.41-.07-.45-.15c-.35-.15-.5-.3-.45-.44a.86.86,0,0,0,0-.51c0-.13,0-.17.15-.26s-.05-.05,0-.15.29,0,.26-.16.11-.19.4-.25.7,0,.79.13.28-.06.29.11a.51.51,0,0,0,.14.31c.1.2.12.32.06.39S41.07-258.33,41.11-258.29Z"
          />
        </clipPath>
        <clipPath id="clip-path-67">
          <rect
            className="localsearchlAnzac-cls-2"
            x="39.04"
            y="-292.06"
            width="2.85"
            height="15.36"
          />
        </clipPath>
        <clipPath id="clip-path-68">
          <rect
            className="localsearchlAnzac-cls-2"
            x="76.11"
            y="-292.06"
            width="2.85"
            height="15.36"
          />
        </clipPath>
        <clipPath id="clip-path-69">
          <path
            className="localsearchlAnzac-cls-1"
            d="M65.42-279.45a3.22,3.22,0,0,1,.23-1.24,3.1,3.1,0,0,1,.65-.94,3.28,3.28,0,0,1,1-.63,5.3,5.3,0,0,1,1.17-.33l2.46-.37a.89.89,0,0,0,.6-.27.76.76,0,0,0,.16-.47,1.32,1.32,0,0,0-.41-1,1.81,1.81,0,0,0-1.27-.4,1.76,1.76,0,0,0-1.38.5,1.92,1.92,0,0,0-.54,1.18l-2.4-.54a3.36,3.36,0,0,1,.37-1.22,3.55,3.55,0,0,1,.84-1.1,4.18,4.18,0,0,1,1.3-.79,5,5,0,0,1,1.79-.3,5.5,5.5,0,0,1,2,.34,3.84,3.84,0,0,1,1.35.87,3.36,3.36,0,0,1,.75,1.26,5.12,5.12,0,0,1,.23,1.51l0,5.13c0,.28,0,.58,0,.9s0,.56.08.75H71.9a5,5,0,0,1-.07-.59c0-.24,0-.47,0-.66a3.56,3.56,0,0,1-1.11,1.07,3.38,3.38,0,0,1-1.85.46,3.64,3.64,0,0,1-1.43-.27,3.46,3.46,0,0,1-1.09-.7,3.06,3.06,0,0,1-.68-1A3,3,0,0,1,65.42-279.45Zm4,1.06a2.87,2.87,0,0,0,.83-.12,1.64,1.64,0,0,0,.7-.4,2,2,0,0,0,.49-.74,3.1,3.1,0,0,0,.19-1.15v-.47l-2.26.36a1.76,1.76,0,0,0-.89.38,1.15,1.15,0,0,0-.36.92,1.24,1.24,0,0,0,.33.84A1.24,1.24,0,0,0,69.42-278.39Z"
          />
        </clipPath>
        <clipPath id="clip-path-70">
          <path
            className="localsearchlAnzac-cls-1"
            d="M53.32-284s0,0,0-.05a5.13,5.13,0,0,0-1.09-1.75A5.1,5.1,0,0,0,50.55-287a5.2,5.2,0,0,0-2.09-.42,5.37,5.37,0,0,0-2.09.4,5.27,5.27,0,0,0-1.67,1.14,5.4,5.4,0,0,0-1.11,1.74,6.18,6.18,0,0,0-.4,2.23,5.68,5.68,0,0,0,.39,2.21,5.23,5.23,0,0,0,1.09,1.75,4.74,4.74,0,0,0,1.66,1.16,5.38,5.38,0,0,0,2.09.43,5.41,5.41,0,0,0,2.09-.41,4.85,4.85,0,0,0,1.67-1.15,5.21,5.21,0,0,0,1.1-1.74s0,0,0,0a8,8,0,0,1-.29-2.16,8.08,8.08,0,0,1,.31-2.18m-2.56,3.46a2.8,2.8,0,0,1-.56.92,2.35,2.35,0,0,1-.82.56,2.62,2.62,0,0,1-1,.18,2.45,2.45,0,0,1-1-.19,2.3,2.3,0,0,1-.81-.57,2.7,2.7,0,0,1-.56-.92,3.63,3.63,0,0,1-.21-1.29,3.78,3.78,0,0,1,.22-1.29,2.72,2.72,0,0,1,.57-.92,2.15,2.15,0,0,1,.81-.56,2.53,2.53,0,0,1,1-.19,2.5,2.5,0,0,1,1,.2,2.27,2.27,0,0,1,.81.56,2.83,2.83,0,0,1,.55.93,3.18,3.18,0,0,1,.21,1.29,3.42,3.42,0,0,1-.22,1.29"
          />
        </clipPath>
        <clipPath id="clip-path-71">
          <path
            className="localsearchlAnzac-cls-1"
            d="M59.79-284.77a2.53,2.53,0,0,0-1,.19A2.23,2.23,0,0,0,58-284a2.68,2.68,0,0,0-.55.92,3.43,3.43,0,0,0-.21,1.24,3.68,3.68,0,0,0,.2,1.25,2.67,2.67,0,0,0,.56.94,2.17,2.17,0,0,0,.81.57,2.47,2.47,0,0,0,1,.2,2.33,2.33,0,0,0,.9-.16,2.26,2.26,0,0,0,.69-.41,2,2,0,0,0,.46-.57,2.81,2.81,0,0,0,.25-.61l2.38.84a4.86,4.86,0,0,1-.54,1.28,4.47,4.47,0,0,1-1,1.11,4.47,4.47,0,0,1-1.38.8,4.64,4.64,0,0,1-1.79.3,5.11,5.11,0,0,1-2.07-.42A5,5,0,0,1,56-277.9a5.41,5.41,0,0,1-1.12-1.75,5.89,5.89,0,0,1-.4-2.22,6.17,6.17,0,0,1,.41-2.22A5.19,5.19,0,0,1,56-285.83,5,5,0,0,1,57.69-287a5,5,0,0,1,2.05-.4,5.18,5.18,0,0,1,1.82.31,5.22,5.22,0,0,1,1.39.8,4.09,4.09,0,0,1,.95,1.13,5.09,5.09,0,0,1,.53,1.29L62-283a2.82,2.82,0,0,0-.7-1.21,2,2,0,0,0-1.51-.56"
          />
        </clipPath>
        <clipPath id="clip-path-72">
          <rect
            className="localsearchlAnzac-cls-2"
            x="39.04"
            y="-270.88"
            width="39.55"
            height="2.82"
          />
        </clipPath>
        <clipPath id="clip-path-73">
          <path
            className="localsearchlAnzac-cls-1"
            d="M121.05-86.83a512.37,512.37,0,0,0,118,1.39,512.38,512.38,0,0,0,115.13-25.89l4.73,45A496.42,496.42,0,0,1,244.82-40.53a522.64,522.64,0,0,1-119-1.28Z"
          />
        </clipPath>
        <clipPath id="clip-path-74">
          <polygon
            className="localsearchlAnzac-cls-1"
            points="355.98 -113.59 414.76 -119.76 398.97 -96.18 419.5 -74.75 360.71 -68.57 355.98 -113.59"
          />
        </clipPath>
        <clipPath id="clip-path-75">
          <polygon
            className="localsearchlAnzac-cls-1"
            points="123.54 -82.48 64.76 -88.66 80.55 -65.07 60.02 -43.64 118.81 -37.47 123.54 -82.48"
          />
        </clipPath>
        <clipPath id="clip-path-76">
          <path
            className="localsearchlAnzac-cls-1"
            d="M333-106.79q3-7.5,7.31-9.19c4.34-1.69,4.25-3.27,6.79-3.27s3.09-.3,4.86,3.92q1.77,4.23.6,16.25-12.35.12-17.05-1.28T333-106.79Z"
          />
        </clipPath>
        <clipPath id="clip-path-77">
          <path
            className="localsearchlAnzac-cls-1"
            d="M369.81-106.74q-3-7.5-7.31-9.19c-4.34-1.69-4.25-3.27-6.79-3.27s-3.08-.31-4.85,3.92Q349.09-111,350.25-99q12.35.12,17.05-1.29T369.81-106.74Z"
          />
        </clipPath>
        <clipPath id="clip-path-78">
          <path
            className="localsearchlAnzac-cls-1"
            d="M344.76-81.74q-7.47-3-9.16-7.34c-1.68-4.36-3.26-4.27-3.26-6.82s-.3-3.09,3.92-4.87q4.2-1.78,16.18-.61.12,12.41-1.28,17.12T344.76-81.74Z"
          />
        </clipPath>
        <clipPath id="clip-path-79">
          <path
            className="localsearchlAnzac-cls-1"
            d="M357.54-82.3q7.47-3,9.16-7.34C368.38-94,370-93.9,370-96.45s.31-3.1-3.91-4.88q-4.2-1.77-16.18-.61-.12,12.41,1.28,17.13T357.54-82.3Z"
          />
        </clipPath>
        <clipPath id="clip-path-80">
          <path
            className="localsearchlAnzac-cls-1"
            d="M355.89-99.88c.19.21.91,2-.19,2.18s-.86,1.48-1.4,1.48-1.08,1.82-1.36,1.33-.55,0-2.48,0c-1.29,0-2-.23-2.24-.67-1.77-.73-2.55-1.5-2.33-2.32a5.4,5.4,0,0,0-.18-2.75c-.11-.75.18-1,.67-1.49s-.27-.25.2-.83,1.43-.14,1.23-1c-.14-.55.5-1,1.9-1.51,2.17-.28,3.5-.11,4,.51.71.93,1.34-.4,1.44.5a3.17,3.17,0,0,0,.77,1.7c.54,1,.68,1.73.39,2.08C355.86-100.1,355.7-100.09,355.89-99.88Z"
          />
        </clipPath>
        <clipPath id="clip-path-81">
          <rect
            className="localsearchlAnzac-cls-2"
            x="-1.47"
            y="-142.19"
            width="10.19"
            height="50.96"
          />
        </clipPath>
        <clipPath id="clip-path-82">
          <rect
            className="localsearchlAnzac-cls-2"
            x="123.37"
            y="-142.19"
            width="10.19"
            height="50.96"
          />
        </clipPath>
        <clipPath id="clip-path-83">
          <path
            className="localsearchlAnzac-cls-1"
            d="M87.42-100.67a9.85,9.85,0,0,1,.8-4.07,9.72,9.72,0,0,1,2.18-3.1,10.26,10.26,0,0,1,3.19-2.07,17.53,17.53,0,0,1,4-1.1l8.31-1.22a3.11,3.11,0,0,0,2-.87,2.35,2.35,0,0,0,.56-1.56,4.15,4.15,0,0,0-1.4-3.14,6,6,0,0,0-4.28-1.35,6.18,6.18,0,0,0-4.64,1.66,6.3,6.3,0,0,0-1.83,3.89l-8.09-1.77a11.44,11.44,0,0,1,1.25-4A12.49,12.49,0,0,1,92.24-123a14,14,0,0,1,4.4-2.6,16.78,16.78,0,0,1,6-1,19.12,19.12,0,0,1,6.79,1.1,12.69,12.69,0,0,1,4.55,2.88,10.66,10.66,0,0,1,2.52,4.16,15.44,15.44,0,0,1,.77,4.95l-.06,16.87c0,.93,0,1.91.12,3s.18,1.87.27,2.48l-8.38,0c-.09-.46-.16-1.1-.23-1.92s-.09-1.54-.09-2.19a12.08,12.08,0,0,1-3.75,3.54A11.54,11.54,0,0,1,99-90.3a12.83,12.83,0,0,1-4.83-.9,11.32,11.32,0,0,1-3.66-2.31,9.63,9.63,0,0,1-2.29-3.29A9.66,9.66,0,0,1,87.42-100.67Zm13.5,3.47a9.87,9.87,0,0,0,2.78-.37,5.89,5.89,0,0,0,2.37-1.31,6.8,6.8,0,0,0,1.66-2.44,10.19,10.19,0,0,0,.63-3.79v-1.54l-7.62,1.16a5.93,5.93,0,0,0-3,1.27,3.75,3.75,0,0,0-1.22,3,4,4,0,0,0,1.09,2.76A4.17,4.17,0,0,0,100.92-97.2Z"
          />
        </clipPath>
        <clipPath id="clip-path-84">
          <path
            className="localsearchlAnzac-cls-1"
            d="M46.64-115.81s0-.1,0-.15a17.13,17.13,0,0,0-3.68-5.77,17.11,17.11,0,0,0-5.61-3.79,18.17,18.17,0,0,0-7-1.38,18,18,0,0,0-7,1.33,16.9,16.9,0,0,0-5.64,3.74,17.22,17.22,0,0,0-3.73,5.73,19.58,19.58,0,0,0-1.36,7.32,19.13,19.13,0,0,0,1.31,7.28,17.53,17.53,0,0,0,3.68,5.77,16.63,16.63,0,0,0,5.61,3.82,18,18,0,0,0,7,1.39,18,18,0,0,0,7-1.33,16.51,16.51,0,0,0,5.64-3.78,17.48,17.48,0,0,0,3.73-5.73l.06-.17a25.05,25.05,0,0,1-1-7.12,25.75,25.75,0,0,1,1-7.16M38-104.43a9.38,9.38,0,0,1-1.9,3,7.63,7.63,0,0,1-2.75,1.83,8.66,8.66,0,0,1-3.23.62,8.61,8.61,0,0,1-3.22-.65,7.68,7.68,0,0,1-2.74-1.85,9.33,9.33,0,0,1-1.88-3,11.74,11.74,0,0,1-.7-4.26,11.49,11.49,0,0,1,.74-4.25,9.27,9.27,0,0,1,1.9-3A7.78,7.78,0,0,1,27-117.86a8.82,8.82,0,0,1,3.23-.61,8.64,8.64,0,0,1,3.22.64A7.67,7.67,0,0,1,36.2-116a9.31,9.31,0,0,1,1.87,3,11.31,11.31,0,0,1,.7,4.25,11.42,11.42,0,0,1-.73,4.25"
          />
        </clipPath>
        <clipPath id="clip-path-85">
          <path
            className="localsearchlAnzac-cls-1"
            d="M68.45-118.17a8.72,8.72,0,0,0-3.33.61,7.71,7.71,0,0,0-2.72,1.84,8.87,8.87,0,0,0-1.86,3,11.5,11.5,0,0,0-.7,4.11,11.53,11.53,0,0,0,.66,4.12,9,9,0,0,0,1.88,3.07,7.75,7.75,0,0,0,2.74,1.89,8.47,8.47,0,0,0,3.32.64,8.4,8.4,0,0,0,3.06-.5,8,8,0,0,0,2.3-1.35,7.23,7.23,0,0,0,1.55-1.88,9.85,9.85,0,0,0,.87-2l8,2.75a15,15,0,0,1-1.83,4.21A14.79,14.79,0,0,1,79.12-94a16.18,16.18,0,0,1-4.67,2.63,16.9,16.9,0,0,1-6,1,17.83,17.83,0,0,1-7-1.39,17.1,17.1,0,0,1-5.65-3.82,18,18,0,0,1-3.75-5.77,19,19,0,0,1-1.34-7.29,19.53,19.53,0,0,1,1.37-7.31,17.11,17.11,0,0,1,3.73-5.74,17.22,17.22,0,0,1,5.57-3.74,17.53,17.53,0,0,1,6.9-1.33,17.46,17.46,0,0,1,6.13,1,16.71,16.71,0,0,1,4.69,2.63,13.59,13.59,0,0,1,3.21,3.71,16.19,16.19,0,0,1,1.77,4.26l-8.17,2.75a9.39,9.39,0,0,0-2.36-4,6.79,6.79,0,0,0-5.1-1.83"
          />
        </clipPath>
        <clipPath id="clip-path-86">
          <rect
            className="localsearchlAnzac-cls-2"
            x="-1.47"
            y="-141.62"
            width="323.01"
            height="78.42"
          />
        </clipPath>
        <clipPath id="clip-path-87">
          <path
            className="localsearchlAnzac-cls-1"
            d="M113.7-49.8q2.17-5,5.35-6.12c3.19-1.13,3.12-2.19,5-2.19s2.26-.2,3.56,2.62q1.29,2.82.44,10.83-9.06.07-12.51-.85C113.23-46.14,112.62-47.56,113.7-49.8Z"
          />
        </clipPath>
        <clipPath id="clip-path-88">
          <path
            className="localsearchlAnzac-cls-1"
            d="M140.7-49.76c-1.46-3.34-3.24-5.38-5.36-6.13-3.19-1.13-3.12-2.18-5-2.18s-2.26-.21-3.56,2.61q-1.29,2.82-.44,10.84,9.06.07,12.51-.86C141.16-46.11,141.77-47.53,140.7-49.76Z"
          />
        </clipPath>
        <clipPath id="clip-path-89">
          <path
            className="localsearchlAnzac-cls-1"
            d="M122.33-33.1q-5.49-2-6.72-4.89c-1.23-2.91-2.39-2.85-2.39-4.55s-.22-2.06,2.87-3.25q3.09-1.18,11.87-.4.08,8.27-.94,11.41T122.33-33.1Z"
          />
        </clipPath>
        <clipPath id="clip-path-90">
          <path
            className="localsearchlAnzac-cls-1"
            d="M131.69-33.47c3.66-1.32,5.9-3,6.72-4.89,1.23-2.91,2.39-2.85,2.39-4.55s.22-2.06-2.87-3.25q-3.09-1.19-11.87-.4-.07,8.27.94,11.41T131.69-33.47Z"
          />
        </clipPath>
        <clipPath id="clip-path-91">
          <path
            className="localsearchlAnzac-cls-1"
            d="M130.49-45.19c.14.14.66,1.33-.14,1.45s-.63,1-1,1-.79,1.21-1,.88-.4,0-1.82,0c-.94,0-1.49-.15-1.64-.44-1.3-.49-1.87-1-1.71-1.55a3.22,3.22,0,0,0-.13-1.83c-.08-.5.13-.66.49-1s-.19-.17.15-.56,1-.09.9-.64c-.1-.36.37-.7,1.39-1,1.6-.18,2.57-.07,2.91.34.52.63,1-.26,1.06.34a2.06,2.06,0,0,0,.57,1.14c.4.68.49,1.14.29,1.38S130.35-45.33,130.49-45.19Z"
          />
        </clipPath>
        <clipPath id="clip-path-92">
          <path
            className="localsearchlAnzac-cls-1"
            d="M47.6-192.78a201.75,201.75,0,0,0,46.31.54,201.09,201.09,0,0,0,45.18-10.16L141-184.73a194.88,194.88,0,0,1-44.78,10.12,205.34,205.34,0,0,1-46.72-.51Z"
          />
        </clipPath>
        <clipPath id="clip-path-93">
          <polygon
            className="localsearchlAnzac-cls-1"
            points="139.81 -203.29 162.88 -205.71 156.68 -196.45 164.73 -188.04 141.66 -185.62 139.81 -203.29"
          />
        </clipPath>
        <clipPath id="clip-path-94">
          <polygon
            className="localsearchlAnzac-cls-1"
            points="48.57 -191.08 25.5 -193.5 31.7 -184.25 23.64 -175.84 46.72 -173.41 48.57 -191.08"
          />
        </clipPath>
        <clipPath id="clip-path-95">
          <path
            className="localsearchlAnzac-cls-1"
            d="M130.78-200.62q1.17-2.94,2.87-3.61c1.7-.66,1.67-1.28,2.67-1.28s1.21-.12,1.9,1.54c.47,1.11.55,3.23.24,6.38a26,26,0,0,1-6.69-.51Q129.92-198.64,130.78-200.62Z"
          />
        </clipPath>
        <clipPath id="clip-path-96">
          <path
            className="localsearchlAnzac-cls-1"
            d="M145.23-200.6c-.77-2-1.73-3.17-2.86-3.61-1.71-.66-1.67-1.28-2.67-1.28s-1.21-.12-1.91,1.54c-.46,1.11-.54,3.23-.23,6.38a26,26,0,0,0,6.69-.51C145.48-198.45,145.81-199.29,145.23-200.6Z"
          />
        </clipPath>
        <clipPath id="clip-path-97">
          <path
            className="localsearchlAnzac-cls-1"
            d="M135.4-190.79q-2.93-1.17-3.59-2.88c-.66-1.71-1.28-1.67-1.28-2.67s-.12-1.22,1.53-1.92c1.11-.46,3.22-.54,6.36-.24a26.22,26.22,0,0,1-.51,6.72C137.55-190.54,136.71-190.21,135.4-190.79Z"
          />
        </clipPath>
        <clipPath id="clip-path-98">
          <path
            className="localsearchlAnzac-cls-1"
            d="M140.42-191q2.93-1.17,3.59-2.88c.66-1.71,1.28-1.67,1.28-2.67s.12-1.22-1.54-1.92c-1.1-.46-3.21-.54-6.35-.23a26.32,26.32,0,0,0,.51,6.72C138.27-190.76,139.11-190.43,140.42-191Z"
          />
        </clipPath>
        <clipPath id="clip-path-99">
          <path
            className="localsearchlAnzac-cls-1"
            d="M139.77-197.91c.08.09.36.79-.07.86s-.34.58-.55.58-.43.71-.54.52-.21,0-1,0c-.51,0-.8-.09-.88-.26-.7-.29-1-.59-.91-.91a2.15,2.15,0,0,0-.07-1.08c-.05-.3.07-.39.26-.59s-.11-.09.07-.32.57-.06.49-.38.19-.41.74-.59c.86-.11,1.38,0,1.56.2s.53-.16.57.2a1.2,1.2,0,0,0,.3.66c.21.41.26.68.15.82S139.7-198,139.77-197.91Z"
          />
        </clipPath>
        <clipPath id="clip-path-100">
          <rect
            className="localsearchlAnzac-cls-2"
            x="-0.49"
            y="-214.51"
            width="4"
            height="20"
          />
        </clipPath>
        <clipPath id="clip-path-101">
          <rect
            className="localsearchlAnzac-cls-2"
            x="48.51"
            y="-214.51"
            width="4"
            height="20"
          />
        </clipPath>
        <clipPath id="clip-path-102">
          <path
            className="localsearchlAnzac-cls-1"
            d="M34.4-198.22a3.87,3.87,0,0,1,.31-1.6,3.84,3.84,0,0,1,.85-1.21,4.28,4.28,0,0,1,1.26-.82,7.34,7.34,0,0,1,1.55-.43l3.26-.48a1.18,1.18,0,0,0,.78-.33.92.92,0,0,0,.22-.62,1.64,1.64,0,0,0-.55-1.23,2.33,2.33,0,0,0-1.68-.53,2.41,2.41,0,0,0-1.82.65,2.55,2.55,0,0,0-.72,1.53l-3.17-.7a4.38,4.38,0,0,1,.49-1.58A4.85,4.85,0,0,1,36.29-207,5.43,5.43,0,0,1,38-208a6.62,6.62,0,0,1,2.37-.39,7.44,7.44,0,0,1,2.66.44,4.86,4.86,0,0,1,1.79,1.13,4.26,4.26,0,0,1,1,1.63,6.3,6.3,0,0,1,.3,1.94l0,6.62c0,.37,0,.76,0,1.17s.07.73.11,1l-3.29,0q0-.27-.09-.75c0-.32,0-.6,0-.86a4.59,4.59,0,0,1-1.47,1.39,4.44,4.44,0,0,1-2.44.59,5,5,0,0,1-1.9-.35,4.43,4.43,0,0,1-1.43-.91,3.59,3.59,0,0,1-.9-1.29A3.59,3.59,0,0,1,34.4-198.22Zm5.3,1.37a4,4,0,0,0,1.09-.15,2.26,2.26,0,0,0,.93-.52,2.67,2.67,0,0,0,.65-.95,4.17,4.17,0,0,0,.25-1.49v-.6l-3,.45a2.39,2.39,0,0,0-1.18.5,1.47,1.47,0,0,0-.47,1.19,1.6,1.6,0,0,0,.42,1.08A1.7,1.7,0,0,0,39.7-196.85Z"
          />
        </clipPath>
        <clipPath id="clip-path-103">
          <path
            className="localsearchlAnzac-cls-1"
            d="M18.39-204.16l0-.06a6.83,6.83,0,0,0-1.44-2.26A6.78,6.78,0,0,0,14.72-208a7,7,0,0,0-2.75-.54A7.08,7.08,0,0,0,9.2-208,6.58,6.58,0,0,0,7-206.52a6.58,6.58,0,0,0-1.46,2.25A7.45,7.45,0,0,0,5-201.4a7.78,7.78,0,0,0,.51,2.86A6.9,6.9,0,0,0,7-196.28a6.62,6.62,0,0,0,2.2,1.5,7.19,7.19,0,0,0,2.76.55,7,7,0,0,0,2.76-.53,6.6,6.6,0,0,0,2.22-1.48,6.94,6.94,0,0,0,1.46-2.25.64.64,0,0,0,0-.07,9.75,9.75,0,0,1-.38-2.79,9.94,9.94,0,0,1,.4-2.81M15-199.69a3.49,3.49,0,0,1-.74,1.18,3.18,3.18,0,0,1-1.08.73,3.53,3.53,0,0,1-1.27.24,3.46,3.46,0,0,1-1.26-.26,3,3,0,0,1-1.08-.72,3.57,3.57,0,0,1-.73-1.2,4.46,4.46,0,0,1-.28-1.67,4.49,4.49,0,0,1,.29-1.67,3.62,3.62,0,0,1,.75-1.18,2.85,2.85,0,0,1,1.08-.72A3.07,3.07,0,0,1,12-205.2a3.34,3.34,0,0,1,1.27.25,2.92,2.92,0,0,1,1.07.73A3.54,3.54,0,0,1,15-203a4.5,4.5,0,0,1,.27,1.67,4.49,4.49,0,0,1-.29,1.67"
          />
        </clipPath>
        <clipPath id="clip-path-104">
          <path
            className="localsearchlAnzac-cls-1"
            d="M27-205.09a3.55,3.55,0,0,0-1.31.24,3.21,3.21,0,0,0-1.06.72,3.46,3.46,0,0,0-.73,1.19,4.28,4.28,0,0,0-.28,1.61,4.55,4.55,0,0,0,.26,1.62,3.68,3.68,0,0,0,.74,1.21,3.12,3.12,0,0,0,1.07.74,3.36,3.36,0,0,0,1.31.25,3.21,3.21,0,0,0,1.2-.2,2.86,2.86,0,0,0,.9-.53,2.68,2.68,0,0,0,.61-.74,3.55,3.55,0,0,0,.34-.79l3.15,1.08a6.19,6.19,0,0,1-.72,1.66,6.24,6.24,0,0,1-1.29,1.44,6.26,6.26,0,0,1-1.83,1,6.87,6.87,0,0,1-2.38.39,7.12,7.12,0,0,1-2.73-.55,6.66,6.66,0,0,1-2.21-1.5,6.79,6.79,0,0,1-1.47-2.26,7.21,7.21,0,0,1-.53-2.86,7.45,7.45,0,0,1,.54-2.87A6.68,6.68,0,0,1,22-206.46a6.6,6.6,0,0,1,2.19-1.47,6.7,6.7,0,0,1,2.7-.52,7,7,0,0,1,2.41.4,6.68,6.68,0,0,1,1.84,1,5.25,5.25,0,0,1,1.26,1.45,6.83,6.83,0,0,1,.7,1.67l-3.21,1.09a3.7,3.7,0,0,0-.93-1.57,2.69,2.69,0,0,0-2-.72"
          />
        </clipPath>
        <clipPath id="clip-path-105">
          <rect
            className="localsearchlAnzac-cls-2"
            x="-0.49"
            y="-214.29"
            width="126.78"
            height="30.78"
          />
        </clipPath>
        <clipPath id="clip-path-106">
          <path
            className="localsearchlAnzac-cls-1"
            d="M44.71-178.25a4.05,4.05,0,0,1,2.1-2.41c1.25-.44,1.23-.85,2-.85s.89-.08,1.4,1a9.39,9.39,0,0,1,.17,4.25,20.79,20.79,0,0,1-4.91-.34Q44.08-176.93,44.71-178.25Z"
          />
        </clipPath>
        <clipPath id="clip-path-107">
          <path
            className="localsearchlAnzac-cls-1"
            d="M55.31-178.24a4,4,0,0,0-2.11-2.4c-1.25-.44-1.22-.86-2-.86s-.89-.08-1.4,1a9.26,9.26,0,0,0-.17,4.25,20.84,20.84,0,0,0,4.91-.34Q55.94-176.92,55.31-178.24Z"
          />
        </clipPath>
        <clipPath id="clip-path-108">
          <path
            className="localsearchlAnzac-cls-1"
            d="M48.1-171.7a4.21,4.21,0,0,1-2.64-1.92c-.48-1.14-.94-1.11-.94-1.78s-.08-.81,1.13-1.28a12.17,12.17,0,0,1,4.66-.15,16.19,16.19,0,0,1-.37,4.48C49.67-171.53,49.06-171.31,48.1-171.7Z"
          />
        </clipPath>
        <clipPath id="clip-path-109">
          <path
            className="localsearchlAnzac-cls-1"
            d="M51.77-171.84a4.21,4.21,0,0,0,2.64-1.92c.48-1.14.94-1.12.94-1.79s.08-.81-1.13-1.27a12.32,12.32,0,0,0-4.66-.16,16.55,16.55,0,0,0,.37,4.48C50.2-171.68,50.81-171.46,51.77-171.84Z"
          />
        </clipPath>
        <clipPath id="clip-path-110">
          <path
            className="localsearchlAnzac-cls-1"
            d="M51.3-176.44c.06.05.26.52,0,.57s-.25.38-.41.38-.31.48-.39.35-.16,0-.71,0c-.37,0-.59-.06-.65-.17-.51-.19-.73-.4-.67-.61a1.27,1.27,0,0,0-.05-.72c0-.2.05-.26.19-.39s-.07-.06.06-.22.41,0,.35-.25.15-.27.55-.39c.63-.08,1,0,1.14.13s.39-.1.42.13a.8.8,0,0,0,.22.45c.16.27.19.45.11.54S51.25-176.5,51.3-176.44Z"
          />
        </clipPath>
      </defs>
      <g className="localsearchlAnzac-cls-3">
        <g className="localsearchlAnzac-cls-4">
          <rect
            className="localsearchlAnzac-cls-5"
            x="512.5"
            y="141.79"
            width="1178.88"
            height="383.12"
            transform="translate(-28.81 117.01) rotate(-6)"
          />
        </g>
      </g>
      <g className="localsearchlAnzac-cls-6">
        <g className="localsearchlAnzac-cls-4">
          <rect
            className="localsearchlAnzac-cls-5"
            x="1577.12"
            y="62.12"
            width="383.71"
            height="320.9"
            transform="translate(-13.57 186.13) rotate(-6)"
          />
        </g>
      </g>
      <g className="localsearchlAnzac-cls-7">
        <g className="localsearchlAnzac-cls-4">
          <rect
            className="localsearchlAnzac-cls-5"
            x="265.99"
            y="171.83"
            width="320.9"
            height="383.71"
            transform="matrix(0.1, -0.99, 0.99, 0.1, 20.18, 749.77)"
          />
        </g>
      </g>
      <g className="localsearchlAnzac-cls-8">
        <g className="localsearchlAnzac-cls-4">
          <rect
            className="localsearchlAnzac-cls-9"
            x="1459.68"
            y="50.98"
            width="209.58"
            height="207.16"
          />
        </g>
      </g>
      <g className="localsearchlAnzac-cls-10">
        <g className="localsearchlAnzac-cls-4">
          <rect
            className="localsearchlAnzac-cls-11"
            x="1539.04"
            y="51.19"
            width="209.58"
            height="207.16"
          />
        </g>
      </g>
      <g className="localsearchlAnzac-cls-12">
        <g className="localsearchlAnzac-cls-4">
          <rect
            className="localsearchlAnzac-cls-11"
            x="1459.89"
            y="129.96"
            width="206.8"
            height="209.95"
          />
        </g>
      </g>
      <g className="localsearchlAnzac-cls-13">
        <g className="localsearchlAnzac-cls-4">
          <rect
            className="localsearchlAnzac-cls-9"
            x="1539.32"
            y="127.44"
            width="206.8"
            height="209.95"
          />
        </g>
      </g>
      <g className="localsearchlAnzac-cls-14">
        <g className="localsearchlAnzac-cls-4">
          <rect x="1520.45" y="113.14" width="164.29" height="164.32" />
        </g>
      </g>
      <g className="localsearchlAnzac-cls-15">
        <g className="localsearchlAnzac-cls-4">
          <rect
            className="localsearchlAnzac-cls-16"
            x="-54.37"
            y="-53.04"
            width="161.81"
            height="346.73"
          />
        </g>
      </g>
      <g className="localsearchlAnzac-cls-17">
        <g className="localsearchlAnzac-cls-4">
          <rect
            className="localsearchlAnzac-cls-16"
            x="511.96"
            y="-53.04"
            width="161.81"
            height="346.73"
          />
        </g>
      </g>
      <g className="localsearchlAnzac-cls-18">
        <g className="localsearchlAnzac-cls-4">
          <rect
            className="localsearchlAnzac-cls-16"
            x="348.85"
            y="17.64"
            width="252.66"
            height="280.25"
          />
        </g>
      </g>
      <g className="localsearchlAnzac-cls-19">
        <g className="localsearchlAnzac-cls-4">
          <rect
            className="localsearchlAnzac-cls-16"
            x="8.98"
            y="16.29"
            width="270.47"
            height="280.63"
          />
        </g>
      </g>
      <g className="localsearchlAnzac-cls-20">
        <g className="localsearchlAnzac-cls-4">
          <rect
            className="localsearchlAnzac-cls-16"
            x="182.33"
            y="17"
            width="267.64"
            height="280.64"
          />
        </g>
      </g>
      <g className="localsearchlAnzac-cls-21">
        <g className="localsearchlAnzac-cls-4">
          <g className="localsearchlAnzac-cls-22">
            <g className="localsearchlAnzac-cls-23">
              <g className="localsearchlAnzac-cls-24">
                <g className="localsearchlAnzac-cls-23">
                  <rect
                    className="localsearchlAnzac-cls-25"
                    x="-54.37"
                    y="263.19"
                    width="720.28"
                    height="157.63"
                  />
                </g>
              </g>
              <g className="localsearchlAnzac-cls-26">
                <g className="localsearchlAnzac-cls-23">
                  <rect
                    className="localsearchlAnzac-cls-16"
                    x="569.37"
                    y="15.98"
                    width="231.95"
                    height="281.2"
                  />
                </g>
              </g>
              <g className="localsearchlAnzac-cls-27">
                <g className="localsearchlAnzac-cls-23">
                  <rect
                    className="localsearchlAnzac-cls-16"
                    x="703.68"
                    y="16.26"
                    width="262.09"
                    height="280.87"
                  />
                </g>
              </g>
              <g className="localsearchlAnzac-cls-28">
                <g className="localsearchlAnzac-cls-23">
                  <rect
                    className="localsearchlAnzac-cls-16"
                    x="1284.16"
                    y="-50.3"
                    width="242.34"
                    height="344.57"
                  />
                </g>
              </g>
              <g className="localsearchlAnzac-cls-29">
                <g className="localsearchlAnzac-cls-23">
                  <rect
                    className="localsearchlAnzac-cls-16"
                    x="1112.71"
                    y="17.92"
                    width="261.24"
                    height="280.22"
                  />
                </g>
              </g>
              <g className="localsearchlAnzac-cls-30">
                <g className="localsearchlAnzac-cls-23">
                  <rect
                    className="localsearchlAnzac-cls-16"
                    x="870.25"
                    y="17.22"
                    width="244.43"
                    height="279.95"
                  />
                </g>
              </g>
              <g className="localsearchlAnzac-cls-31">
                <g className="localsearchlAnzac-cls-23">
                  <rect
                    className="localsearchlAnzac-cls-16"
                    x="1028.7"
                    y="16.83"
                    width="198.95"
                    height="277.07"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g className="localsearchlAnzac-cls-32">
        <g className="localsearchlAnzac-cls-4">
          <rect
            className="localsearchlAnzac-cls-9"
            x="465.72"
            y="328.36"
            width="184.51"
            height="176.63"
          />
        </g>
      </g>
      <g className="localsearchlAnzac-cls-33">
        <g className="localsearchlAnzac-cls-4">
          <rect
            className="localsearchlAnzac-cls-11"
            x="523.92"
            y="328.5"
            width="184.51"
            height="176.63"
          />
        </g>
      </g>
      <g className="localsearchlAnzac-cls-34">
        <g className="localsearchlAnzac-cls-4">
          <rect
            className="localsearchlAnzac-cls-11"
            x="465.88"
            y="381.02"
            width="182.48"
            height="178.49"
          />
        </g>
      </g>
      <g className="localsearchlAnzac-cls-35">
        <g className="localsearchlAnzac-cls-4">
          <rect
            className="localsearchlAnzac-cls-9"
            x="524.12"
            y="379.34"
            width="182.48"
            height="178.49"
          />
        </g>
      </g>
      <g className="localsearchlAnzac-cls-36">
        <g className="localsearchlAnzac-cls-4">
          <rect x="510.29" y="369.8" width="151.3" height="148.08" />
        </g>
      </g>
      <path
        className="localsearchlAnzac-cls-56"
        d="M697.4,411.52,709,325.1l12,1.61-10.13,75.21,40.83,5.5-1.51,11.21Z"
      />
      <path
        className="localsearchlAnzac-cls-56"
        d="M818.25,408a25.73,25.73,0,0,1-4.27,7,26.13,26.13,0,0,1-6.28,5.37,28.27,28.27,0,0,1-8,3.3,29.39,29.39,0,0,1-9.57.63A31.09,31.09,0,0,1,779,421.13a27.57,27.57,0,0,1-8.95-7,29.07,29.07,0,0,1-5.61-10.51,35.47,35.47,0,0,1-1.2-13.56,33.54,33.54,0,0,1,3.46-12.48,31.79,31.79,0,0,1,7.06-9.24,27.45,27.45,0,0,1,9.57-5.57,26.21,26.21,0,0,1,10.87-1.32,30.81,30.81,0,0,1,11.86,3.34,24.37,24.37,0,0,1,8.32,7.11A28,28,0,0,1,819,382.15a39.56,39.56,0,0,1,.78,12.73c-.06.73-.15,1.43-.24,2.08a12,12,0,0,1-.33,1.57l-44.35-3.95a20.67,20.67,0,0,0,.83,7.36,17.17,17.17,0,0,0,3.22,6,16.79,16.79,0,0,0,5.31,4.18,18.76,18.76,0,0,0,6.81,1.9q7.23.65,11.33-2.45a19.8,19.8,0,0,0,6.27-8Zm-10-19.79a16.23,16.23,0,0,0-3.33-11.1q-3.66-4.71-11.5-5.41a16.07,16.07,0,0,0-6.67.7,15.22,15.22,0,0,0-5.2,3,17.4,17.4,0,0,0-3.68,4.55,14.76,14.76,0,0,0-1.84,5.39Z"
      />
      <path
        className="localsearchlAnzac-cls-56"
        d="M839.79,406.93a12.66,12.66,0,0,0,3.66,8.07q3.28,3.36,9.55,3.67,4.9.25,7.61-2a7.22,7.22,0,0,0,2.85-5.39,6.47,6.47,0,0,0-1.73-4.89,11.48,11.48,0,0,0-5.51-3.11l-10-2.72a19.23,19.23,0,0,1-10.58-6.43,15.72,15.72,0,0,1-3.33-10.89,16,16,0,0,1,2-7.1,19.46,19.46,0,0,1,4.78-5.73,20.52,20.52,0,0,1,6.89-3.72,22.75,22.75,0,0,1,8.25-1.07,26.17,26.17,0,0,1,10,2.23,21.19,21.19,0,0,1,6.49,4.57,18.79,18.79,0,0,1,3.61,5.41,26.38,26.38,0,0,1,1.55,4.76l-10.39,3.3a25.91,25.91,0,0,0-.72-2.87,10.06,10.06,0,0,0-1.8-3.35,11.33,11.33,0,0,0-3.56-2.83,13.44,13.44,0,0,0-5.71-1.39,10.34,10.34,0,0,0-7.25,2,7.14,7.14,0,0,0-3,5.33q-.29,5.65,6.4,7.46l9.47,2.57q8,2.13,11.91,6.93a16.83,16.83,0,0,1,1.89,17.77,19,19,0,0,1-4.29,5.7,19.7,19.7,0,0,1-6.91,4,25.37,25.37,0,0,1-9.67,1.18A28.87,28.87,0,0,1,842,426.25a23.85,23.85,0,0,1-7-4.66,19.12,19.12,0,0,1-4.14-5.81,18,18,0,0,1-1.63-5.68Z"
      />
      <path
        className="localsearchlAnzac-cls-56"
        d="M907.71,369.3l12.79.24L920.3,380l-12.79-.24-.58,30.74c0,2.71.52,4.75,1.73,6.13s3.32,2.09,6.36,2.15c.73,0,1.55,0,2.46-.08a9.23,9.23,0,0,0,2.1-.33l-.19,9.84c-.5.15-1.44.36-2.84.62a25.26,25.26,0,0,1-5,.33c-5.09-.09-9.07-1.62-12-4.59s-4.29-7.15-4.19-12.56l.61-32.47-11.31-.21.19-10.46,3.2.07q4.8.09,7-2.46A9.85,9.85,0,0,0,897.3,360l.19-9.6,10.57.2Z"
      />
      <path
        className="localsearchlAnzac-cls-56"
        d="M1064,336.94l12.41-.64-20.35,88.36-12.41.64-26.35-69.46-18.85,71.78-12,.62-29.65-85.8,12.41-.64L991.85,409l18.37-69.29,12.65-.65,25.89,67.76Z"
      />
      <path
        className="localsearchlAnzac-cls-56"
        d="M1140.55,399.34a25.7,25.7,0,0,1-2.82,7.66,26.86,26.86,0,0,1-5.12,6.49,28.37,28.37,0,0,1-7.22,4.79,29,29,0,0,1-9.26,2.47,31.17,31.17,0,0,1-11.48-.87,27.84,27.84,0,0,1-10.13-5.1,29.18,29.18,0,0,1-7.54-9.22,35.27,35.27,0,0,1-3.81-13.07,33.21,33.21,0,0,1,1-12.91,31.58,31.58,0,0,1,5.13-10.45,27.51,27.51,0,0,1,8.31-7.32,26.46,26.46,0,0,1,10.4-3.4,30.61,30.61,0,0,1,12.28,1,24.31,24.31,0,0,1,9.54,5.35,27.94,27.94,0,0,1,6.49,9.14,40,40,0,0,1,3.23,12.33c.08.74.13,1.43.16,2.09a12,12,0,0,1,0,1.61l-44.27,4.73a20.6,20.6,0,0,0,2.24,7.06A17,17,0,0,0,1102,407a16.68,16.68,0,0,0,6,3.07,18.83,18.83,0,0,0,7,.54q7.21-.77,10.64-4.6a19.84,19.84,0,0,0,4.6-9Zm-13.61-17.47a16.23,16.23,0,0,0-5.43-10.25q-4.5-3.9-12.33-3.07a15.79,15.79,0,0,0-6.4,2,15.07,15.07,0,0,0-4.53,3.94,17.71,17.71,0,0,0-2.72,5.18,14.69,14.69,0,0,0-.76,5.65Z"
      />
      <path
        className="localsearchlAnzac-cls-56"
        d="M1192.13,409.11l-14.42-86,52.28-8.76,1.85,11-40.39,6.77,4.63,27.66,36.64-6.15,1.87,11.16L1198,371l6.06,36.14Z"
      />
      <path
        className="localsearchlAnzac-cls-56"
        d="M1267.85,333.27a30.23,30.23,0,0,1,12.41-.14,29.47,29.47,0,0,1,10.73,4.49,29.15,29.15,0,0,1,8.17,8.41,34.37,34.37,0,0,1,4.71,11.77,34.74,34.74,0,0,1,.39,12.73,28.86,28.86,0,0,1-4.11,11,29.73,29.73,0,0,1-8,8.4,32.11,32.11,0,0,1-23.85,5,29.52,29.52,0,0,1-10.73-4.48,29,29,0,0,1-8.17-8.47,34.64,34.64,0,0,1-4.73-11.83,34.27,34.27,0,0,1-.38-12.68,29,29,0,0,1,4.12-11,29.63,29.63,0,0,1,8.05-8.4A30.13,30.13,0,0,1,1267.85,333.27Zm10.72,51.41a18.27,18.27,0,0,0,6.58-2.75,16.8,16.8,0,0,0,4.95-5.18,19.13,19.13,0,0,0,2.62-7.33,25.84,25.84,0,0,0-.41-9.21,25.32,25.32,0,0,0-3.29-8.55,19.39,19.39,0,0,0-5.32-5.62,16.92,16.92,0,0,0-6.6-2.76,18.47,18.47,0,0,0-7.14.1,18.26,18.26,0,0,0-6.59,2.76,16.92,16.92,0,0,0-4.95,5.18,19.26,19.26,0,0,0-2.63,7.27,25.08,25.08,0,0,0,.4,9.15,25.79,25.79,0,0,0,3.3,8.61,19.13,19.13,0,0,0,5.33,5.67,16.83,16.83,0,0,0,6.61,2.77A18.28,18.28,0,0,0,1278.57,384.68Z"
      />
      <path
        className="localsearchlAnzac-cls-56"
        d="M1346.64,328.91a35.43,35.43,0,0,0-5,.84q-7,1.72-10.4,6.92t-1,14.63l7.06,28.79-11.23,2.75L1312,325.38l11-2.69,2.46,10a19.5,19.5,0,0,1,2.31-6.33,20.31,20.31,0,0,1,3.54-4.41,16.57,16.57,0,0,1,4.24-2.88,23.63,23.63,0,0,1,4.42-1.59,21.18,21.18,0,0,1,2.24-.42,13,13,0,0,1,1.55-.13Z"
      />
      <path
        className="localsearchlAnzac-cls-56"
        d="M1378.5,370.2a15.91,15.91,0,0,0,7.62,8.64,15.51,15.51,0,0,0,11.83.94q9-2.55,11.89-8.36t.28-15l-2.31-8.17a17.48,17.48,0,0,1-4.63,8.47,21.48,21.48,0,0,1-10.12,5.81,27.1,27.1,0,0,1-11.06.89,25.86,25.86,0,0,1-17.8-10.49,32.06,32.06,0,0,1-5.1-10.57,31.42,31.42,0,0,1-1.17-11.37,27.65,27.65,0,0,1,2.84-10.26,26.12,26.12,0,0,1,16.64-13.47,23.91,23.91,0,0,1,11.68-.75,15.78,15.78,0,0,1,8.39,4.79l-2.25-7.93,11-3.12,14.91,52.66a41.36,41.36,0,0,1,1.58,11,24.55,24.55,0,0,1-2.22,10.47,25.37,25.37,0,0,1-7,8.89,34.59,34.59,0,0,1-12.81,6.24,30.56,30.56,0,0,1-10.33,1.2,27.4,27.4,0,0,1-9.31-2.16,24.45,24.45,0,0,1-7.57-5.08,22.15,22.15,0,0,1-5.06-7.7Zm13.57-17.52a15.66,15.66,0,0,0,10.31-8.29q3.09-6.24.74-14.53t-8.25-12a15.67,15.67,0,0,0-13.12-1.65q-7.45,2.11-10.55,8.35t-.74,14.53q2.38,8.4,8.21,12.06T1392.07,352.68Z"
      />
      <path
        className="localsearchlAnzac-cls-56"
        d="M1485.77,318.93a26.17,26.17,0,0,1-4.81,15.5,28.15,28.15,0,0,1-6,6.2,29.23,29.23,0,0,1-8.54,4.36,31.05,31.05,0,0,1-11.4,1.55,27.57,27.57,0,0,1-11-2.87,29,29,0,0,1-9.3-7.43,35.29,35.29,0,0,1-6.47-12,33.57,33.57,0,0,1-1.76-12.83,31.8,31.8,0,0,1,2.83-11.28,27.57,27.57,0,0,1,6.59-8.9,26.36,26.36,0,0,1,9.46-5.51,30.78,30.78,0,0,1,12.22-1.62,24.54,24.54,0,0,1,10.45,3.23,28.2,28.2,0,0,1,8.25,7.58,39.55,39.55,0,0,1,5.75,11.39c.23.7.43,1.37.59,2a11.85,11.85,0,0,1,.33,1.58l-42.3,13.9a20.93,20.93,0,0,0,3.67,6.44,17.14,17.14,0,0,0,5.35,4.26,16.49,16.49,0,0,0,6.53,1.74,18.64,18.64,0,0,0,7-.95q6.9-2.27,9.44-6.73a19.81,19.81,0,0,0,2.61-9.79Zm-17-14.23a16.25,16.25,0,0,0-7.45-8.88q-5.22-2.86-12.7-.42a16,16,0,0,0-5.84,3.29,15,15,0,0,0-3.6,4.8,17.58,17.58,0,0,0-1.58,5.64,14.77,14.77,0,0,0,.44,5.68Z"
      />
      <path
        className="localsearchlAnzac-cls-56"
        d="M1501.11,268.27l12-4.4,3.59,9.82-12,4.4L1515.27,307c.93,2.54,2.2,4.24,3.83,5.09s3.85.75,6.7-.3c.69-.25,1.45-.57,2.27-1a9.56,9.56,0,0,0,1.83-1.06l3.38,9.24a27.53,27.53,0,0,1-2.42,1.6,24.83,24.83,0,0,1-4.59,2.14q-7.15,2.63-12.82,0t-8.45-10.2l-11.16-30.49L1483.22,286l-3.6-9.82,3-1.1q4.5-1.65,5.63-4.81a9.82,9.82,0,0,0-.21-6.86l-3.3-9,9.93-3.64Z"
      />
    </StyledRoot>
  );
}

SantaLocalsearchLogo.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

SantaLocalsearchLogo.defaultProps = {
  width: 134,
  height: 40,
};

export default SantaLocalsearchLogo;
